import { render, staticRenderFns } from "./personsSerach.vue?vue&type=template&id=4cbc0e20&scoped=true&"
import script from "./personsSerach.vue?vue&type=script&lang=js&"
export * from "./personsSerach.vue?vue&type=script&lang=js&"
import style0 from "./personsSerach.vue?vue&type=style&index=0&id=4cbc0e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc0e20",
  null
  
)

export default component.exports